// extracted by mini-css-extract-plugin
export default {"PostCreate":"qh_a bho_qt bho_a bho_w bho_ea"};